import { Obj } from '../entity.js'
import { ObjOptions } from './base.js'

export class OrganizationObj extends Obj<'Organization'> {
  readonly typeOf = 'Organization' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'Organization' })
  }
}

export function isOrganizationObj(obj: any): obj is OrganizationObj {
  return obj.typeOf === 'Organization'
}

export class GroupObj extends Obj<'Group'> {
  readonly typeOf = 'Group' as const

  public constructor(opts: ObjOptions) {
    super({ ...opts, typeOf: 'Group' })
  }
}

export function isGroupObj(obj: any): obj is GroupObj {
  return obj.typeOf === 'Group'
}

export interface PersonObjOptions extends ObjOptions {
  username?: string
  email?: string
  phone?: string
  instantMessenger?: string
}

export class PersonObj extends Obj<'Person'> {
  readonly typeOf = 'Person' as const
  username: string | undefined
  email: string | undefined
  phone: string | undefined
  instantMessenger: string | undefined

  override get displayName(): string {
    return this.name || this.username || this.key
  }

  public constructor(opts: PersonObjOptions) {
    super({ ...opts, typeOf: 'Person' })
    this.username = opts.username ?? undefined
    this.email = opts.email ?? undefined
    this.phone = opts.phone ?? undefined
    this.instantMessenger = opts.instantMessenger ?? undefined
  }
}

export function isPersonObj(obj: any): obj is PersonObj {
  return obj.typeOf === 'Person'
}

export interface ServiceAccountObjOptions extends ObjOptions {
  username: string
}

export class ServiceAccountObj extends Obj<'ServiceAccount'> {
  readonly typeOf = 'ServiceAccount' as const
  username: string

  public constructor(opts: ServiceAccountObjOptions) {
    super({ ...opts, typeOf: 'ServiceAccount' })
    this.username = opts.username
  }
}

export function isServiceAccountObj(obj: any): obj is ServiceAccountObj {
  return obj.typeOf === 'ServiceAccount'
}
